import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AuthGate, AuthServiceProvider } from '@trp-ta-nitro/auth-react';
import { AuthStatusContext, AuthStatusWrapper } from '@trp-individual-investor-adv-disc/adv-shared';

import { envApiConfig } from '../../components/shared/Links';

const AuthContainer = (props) => {

  const {children, useStatus = false, appBase} = props;

  const getApiConfig = async () => {
    const apiData = await axios.get(`${envApiConfig}`, {
      headers: { 'Application-Type': 'application/json' }
    });
    return apiData.data;
  };

  const determineServiceHost = (options) => {
    const isInternal = window.location.hostname.indexOf('.awstrp.net') !== -1;
    if (options.environment === 'local' || options.environment === 'dev') {
      return isInternal ? 'https://api.dev.awstrp.net/' : 'https://api.dev.troweprice.com/';
    }
    if (options.environment === 'stage') {
      return isInternal ? 'https://api.stage.awstrp.net/' : 'https://api.confidence.troweprice.com/';
    }
    return isInternal ? 'https://api.prod.awstrp.net/' : 'https://api.public.troweprice.com/';
  }

  const [applicationConfig, setApplicationConfig] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const config = await getApiConfig();
        setApplicationConfig({ ...config, serviceHost: determineServiceHost(config) });
      } catch (err) {
        // do nothing
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  if (process.env.REACT_APP_MOCK) {
    return isLoading ? <></> : <AuthStatusContext.Provider
      value={{
                state: {
                    status: {
                        client: 'PRIMARY',
                        businessPartyId: 801207,
                        consent: true,
                        clientHasAccounts: true,
                        coClientHasAccounts: true,
                        clientHasRAS: true,
                        coClientHasRAS: true,
                        clientActivated: false,
                        coClientActivated: false,
                        clientSubmitted: false,
                        coClientSubmitted: false,
                        groupStatus: 'IPLD',
                        error: false,
                        clientRequiresRASU: true,
                        modelChange: true,
                        clientHasInternalAccounts: true,
                        clientHasExternalAccounts: true
                    }
                }
            }}
    >
      {children}
    </AuthStatusContext.Provider>
  }

  return isLoading ? <></> : (
      <AuthServiceProvider options={applicationConfig}>
          <AuthGate externalEntitlements={[]} internalEntitlements={['su-admins']}>
            {useStatus ?
              <AuthStatusWrapper applicationConfig={applicationConfig} appBase={appBase}>
                {children}
              </AuthStatusWrapper>
              : children}
          </AuthGate>
      </AuthServiceProvider>
    )
};

export default AuthContainer;
